module.exports = __webpack_public_path__ + "img/17.9a091f2.jpg";